import req from './../../../fetch';
import { undocumentedResponse } from './../../../utils';
import { AllAPIResponses, CarbonError } from './../../../index';

import { PostPayload } from '..';

type Params = {
  id: number;
};

const del = async (
  params: Params,
  payload: Partial<PostPayload>,
  headers?: Headers
): Promise<AllAPIResponses<{}>> => {
  const resp = await req.del(
    `/api/rules/${params.id}`,
    JSON.stringify(payload),
    headers
  );

  try {
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: {},
          response: clone,
        };
      case 304:
        return {
          error: new Error('Not modified'),
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};
export default del;
